import $http from '@/core/services/http.service';
import { ActionTree } from 'vuex';
import dayjs from 'dayjs';

import { State } from '@/core/store/auth/state';
import Endpoints from '@/constants/endpoints';

export interface Actions {
    authRequest: {
        email: string,
        password: string,
    };
    authLogout: {};
    fetchProfile: {};
}

export const actions: ActionTree<State, any> = {
    authRequest: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            commit('authRequest', payload);
            $http.post(`${Endpoints.login}`, payload)
                .then((res) => {
                    const token = res.data.key;
                    localStorage.setItem('user-token', token);
                    const now = dayjs().set('day', 10);
                    localStorage.setItem('token-expiration-date', now.toString());
                    $http.defaults.headers.common.Authorization = `Token ${token}`;
                    commit('authSuccess', { token });
                    resolve(res);
                }).catch((err) => {
                    commit('authError', payload);
                    localStorage.removeItem('user-token');
                    localStorage.removeItem('token-expiration-date');
                    reject('PARECE QUE LOS DATOS SON INCORRECTOS');
                });
        });
    },
    authLogout: ({ commit }) => {
        return new Promise((resolve) => {
            commit('authLogout', {});
            localStorage.removeItem('user-token');
            localStorage.removeItem('token-expiration-date');
            delete $http.defaults.headers.common.Authorization;
            resolve();
        });
    },
    fetchProfile: ({ commit }) => {
        return new Promise((resolve, reject) => {
            $http.get(`${Endpoints.profile}`)
                .then((res) => {
                    const data = res.data;
                    commit('setProfile', data);
                    resolve(data);
                }).catch((err) => {
                    reject(err);
                });
        });
    },
    fetchuserPermissions: ({ commit }) => {
        return $http.get(`${Endpoints.user_permissions}`)
            .then((res) => {
                const data = res.data;
                commit('setUserPermissions', data);
                return data; 
            })
            .catch((err) => {
                console.error(err); 
                throw err;
            });
    },

};
